// extracted by mini-css-extract-plugin
export default {"div":"Detail_div__3UQ-i","h1":"Detail_h1__cd7h-","h2":"Detail_h2__vjLhk","img":"Detail_img__w-rGC"};